import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const createCurriculumResourceService = (resource) => ({
    list: async () => axios.get(`${API_URL}/cv/${resource}`).then(({data}) => data),
    options: async () => axios.get(`${API_URL}/cv/${resource}/options`).then(({data}) => data),
    getById: async (id) => axios.get(`${API_URL}/cv/${resource}/${id}`).then(({data}) => data),
    create: async (model) => axios.post(`${API_URL}/cv/${resource}`, model).then(({data}) => data),
    edit: async (model, id) => axios.post(`${API_URL}/cv/${resource}/${id}`, model).then(({data}) => data),
    delete: async (id) => axios.delete(`${API_URL}/cv/${resource}/${id}`).then(({data}) => data),
});

export const cvBenefitService = createCurriculumResourceService("benefits");
export const cvQualificationService = createCurriculumResourceService("qualifications");
export const cvDepartmentService = createCurriculumResourceService("departments");
export const cvPositionService = createCurriculumResourceService("positions");

const candidateResourceService = createCurriculumResourceService("candidates");

export const cvCandidateService = {
    ...candidateResourceService,
    list: async (filters) => axios.post(`${API_URL}/cv/candidates/list`, filters).then(({data}) => data),
};
